module.exports = __webpack_public_path__ + "static/media/pt_PT.d9509104.png";